import { ComponentType, useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface IProps {
  location: {
    pathname: string;
  };
  children?: any;
}

const ScrollToTop: React.FC<IProps> = ({
  children,
  location: { pathname },
}) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return children || null;
};

export default withRouter(
  ScrollToTop as ComponentType<RouteComponentProps<any, any, unknown>>
);
